import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { getLocalizedPath, switchLanguagePath, routeMappings, basePathToKey } from '@/utils/localizedRoutes';

// Custom hook to get localized navigation helper
export const useLocalizedNavigation = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  
  // Get localized path for a Swedish base path
  const getLink = (basePath) => {
    return getLocalizedPath(basePath, i18n.language);
  };

  // Navigate to a localized path (supports dynamic segments like /blog/my-slug)
  const navigateTo = (path) => {
    // Try exact match first
    const exact = getLocalizedPath(path, i18n.language);
    if (exact !== path) {
      navigate(exact);
      return;
    }
    // Try splitting: /blog/my-slug → base=/blog, rest=/my-slug
    const segments = path.split('/').filter(Boolean);
    for (let i = segments.length - 1; i >= 1; i--) {
      const base = '/' + segments.slice(0, i).join('/');
      const rest = '/' + segments.slice(i).join('/');
      const localized = getLocalizedPath(base, i18n.language);
      if (localized !== base) {
        navigate(localized + rest);
        return;
      }
    }
    navigate(path);
  };
  
  // Get current routes object for the current language
  const routes = routeMappings[i18n.language] || routeMappings['sv'];
  
  return {
    getLink,
    navigateTo,
    routes,
    currentLang: i18n.language,
  };
};

export default useLocalizedNavigation;
